import { redirect, RouteObject } from "react-router-dom";
import { Layout } from "../Layout/Layout";
import React from "react";

//

const CasesPage = React.lazy(
  async () => await import("../Pages/Cases/CasesPage")
);
const CasesProfilePage = React.lazy(
  async () => await import("../Pages/Cases/Profile/ProfilePage")
);
const CasesBonusePage = React.lazy(
  async () => await import("../Pages/Cases/Bonuse/BonusePage")
);

const CasesDatabasePage = React.lazy(
  async () => await import("../Pages/Cases/Database/DatabasePage")
);
//
export const RouterCases: RouteObject[] = [
  {
    path: "game/case/",
    loader: async () => {
      const table = "database";
      return redirect(`/game/case/${table}`);
    },
  },
  {
    path: "game/case/:table/",
    element: (
      <Layout>
        <CasesPage />
      </Layout>
    ),
  },
  {
    path: "game/case/bonuses/create",
    element: (
      <Layout>
        <CasesBonusePage />
      </Layout>
    ),
  },
  {
    path: "game/case/bonuses/:id/",
    loader: async ({ params }) => {
      const tab = "global";
      return redirect(`/game/case/bonuses/${params.id}/${tab}`);
    },
  },
  {
    path: "game/case/bonuses/:id/:tab",
    element: (
      <Layout>
        <CasesBonusePage />
      </Layout>
    ),
  },
  {
    path: "game/case/profile/create",
    element: (
      <Layout>
        <CasesProfilePage />
      </Layout>
    ),
  },
  {
    path: "game/case/profile/:id/",
    loader: async ({ params }) => {
      const tab = "global";
      return redirect(`/game/case/profile/${params.id}/${tab}`);
    },
  },
  {
    path: "game/case/profile/:id/:tab",
    element: (
      <Layout>
        <CasesProfilePage />
      </Layout>
    ),
  },
  {
    path: "game/case/database/create",
    element: (
      <Layout>
        <CasesDatabasePage />
      </Layout>
    ),
  },
  {
    path: "game/case/database/:id/",
    loader: async ({ params }) => {
      const tab = "global";
      return redirect(`/game/case/database/${params.id}/${tab}`);
    },
  },
  {
    path: "game/case/database/:id/:tab",
    element: (
      <Layout>
        <CasesDatabasePage />
      </Layout>
    ),
  },
];
